module.exports = "//static.hsappstatic.net/signup-ui/static-7.1120/images/verified/icon-outlook.svg"